// @react/hooks/useProjectSprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectSprintStore } from '@core/stores';

/**
 * React hook for Sprint operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectSprint } from '@react/hooks';
 *
 * const SprintList = observer(() => {
 *   const store = useProjectSprint();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectSprint() {
  return projectSprintStore;
}
